/**
 * Created by Rodrigo Quesada on 21/12/16.
 */
import {NgModule} from '@angular/core';
import {PasswordValidatorDirective} from './password-validator.directive';

@NgModule({
    declarations: [PasswordValidatorDirective],
    exports: [PasswordValidatorDirective],
})
export class PasswordValidatorModule {
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/components/forms/validation/password/password-validator.module.ts